/* eslint-disable no-unused-expressions */
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
// import anandhome from "../../assets/images/anandathome.jpg"; 
// import anandhome from "../../assets/images/Health-package-desk.jpg";
// import anandhome from "../../assets/images/anant-at-home-banner-min.png";
// import anandhome from "../../assets/images/Anand-At-Home-Banner.png";
// import anandhome from "../../assets/images/diwali-banner.jpg";
import anandhome from "../../assets/images/anand-at-home-banner.jpg";
import { useForm } from "react-hook-form";
import { API_URL } from "../../Redux/Constant/ApiRoute";
import { FormResponse } from "../../Helpers/FormResponse";
import { CgSpinner } from 'react-icons/cg';
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import axios from "axios";
import ReCAPTCHA from 'react-google-recaptcha';
import commitmentIcon1 from "../../assets/images/commitment-icon-1.png";
import commitmentIcon2 from "../../assets/images/commitment-icon-2.png";
import commitmentIcon3 from "../../assets/images/commitment-icon-3.png";
import GlobalStyle from "../HowItWorks/HowItWorks.module.css";
import how_work1 from '../../assets/images/landing_pages/Share-your-details.png';
import how_work2 from '../../assets/images/landing_pages/Schedule-the-test.png';
import how_work3 from '../../assets/images/landing_pages/visit-your-home-1.png';
import how_work4 from '../../assets/images/landing_pages/visit-your-home.png';
import how_work5 from '../../assets/images/landing_pages/Get-your-reports.png';
import toast from "react-hot-toast";
import { displayApiError } from "../../utils";

export default function AnandatHome() {
  const [open, setOpen] = useState(true)
  const [Loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [verifyEnable,setVerifyEnable] = useState(false)

  const [formEnable,setFormEnable] = useState(true)


  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const extractParamsFromURL = (url) => {
    const params = new URLSearchParams(url.split('?')[1]);
    const extractedParams = {};

    for (const [key, value] of params.entries()) {
      extractedParams[key] = value;
    }

    return extractedParams;
  };

  const currentURL = window.location.href;
  const extractedParams = extractParamsFromURL(currentURL);

  const notesValue = Object.entries(extractedParams).map(([key, value]) => `${key}=${value}`).join('&');

  const notesDataString = JSON.stringify(notesValue);
  // console.log(notesDataString);

  const validEmailCheck  = (email) =>{
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  const validMobileCheck  = (mobile) =>{
    const pattern = /^[6-9]\d{9}$/;
    return pattern.test(mobile);
  }

  const { register, handleSubmit,watch, formState: { errors }, reset } = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        name: Yup.string().required(),
        mobile: Yup.string().matches(/^[6-9]\d{9}$/).required(),
        email: Yup.string().required(),
        otp: Yup.string().required(),
        // message: Yup.string().required()
      })
    )
  })

  const sendOTPEnable = watch('name') && validEmailCheck(watch('email')) && validMobileCheck(watch('mobile'));

  const sendOTP = async () =>{
    const formData = {
      name:watch('name'),
      email:watch('email'),
      mobile:watch('mobile'),
      // page_action:"send_otp"
    }
    try{
     const res = await axios.post(API_URL.SEND_OTP,formData,{
      withCredentials: true
     });
      setVerifyEnable(true);
      toast.success(res?.data?.Message)
    } catch (error) {
      displayApiError(error?.response?.data)
    }
  }

  const verifyOTP = async () =>{
    const formData = {
      name:watch('name'),
      email:watch('email'),
      // page_action:"verify_otp",
      mobile:watch('mobile'),
      otp:watch('otp')
    }
    try{
      const res = await axios.post(API_URL.VERIFY_OTP,formData);
      setFormEnable(false)
       toast.success(res?.data?.Message)
     } catch (error) {
       displayApiError(error?.response?.data)
     }
  }

    const params = new URLSearchParams(window.location.search);
    
    // Create an object to store the UTM and GCLID data
    const capturedUtmData = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_term: params.get('utm_term'),
      utm_content: params.get('utm_content'),
      // 👇 ADDED GCLID HERE
      gclid: params.get('gclid'), 
    };
    
    // Create a concise note for the LeadSquared activity
    const utmNote = `Source: ${capturedUtmData.utm_source || ''}, Medium: ${capturedUtmData.utm_medium || ''}, Campaign: ${capturedUtmData.utm_campaign || ''}`;
    const gclidNote = capturedUtmData.gclid ? ` GCLID: ${capturedUtmData.gclid}` : '';

  const contactUsFrom = (data) => {
    // Calculate current date/time minus 5:30 hours
    const now = new Date();
    const pad= (n) => n.toString().padStart(2, '0');
    const offsetPlus = 5.5 * 60 * 60 * 1000;
    const offsetTimePlus = new Date(now.getTime() + offsetPlus);
    
    const formattedDateTime = 
      `${offsetTimePlus.getFullYear()}-${pad(offsetTimePlus.getMonth() + 1)}-${pad(offsetTimePlus.getDate())} ` +
      `${pad(offsetTimePlus.getHours())}:${pad(offsetTimePlus.getMinutes())}:${pad(offsetTimePlus.getSeconds())}`;


    const offset = -5.5 * 60 * 60 * 1000;
    const offsetTime = new Date(now.getTime() + offset);
    
    const formattedDateTimeActivity = 
      `${offsetTime.getFullYear()}-${pad(offsetTime.getMonth() + 1)}-${pad(offsetTime.getDate())} ` +
      `${pad(offsetTime.getHours())}:${pad(offsetTime.getMinutes())}:${pad(offsetTime.getSeconds())}`;


    const formData = {
      "LeadDetails": [
        {
          "Attribute": "FirstName",
          "Value": data.name
        },
        {
          "Attribute": "LastName",
          "Value": ""
        },
        {
          "Attribute": "EmailAddress",
          "Value": data.email
        },
        {
          "Attribute": "Phone",
          "Value": data.mobile
        },
        {
          "Attribute": "SearchBy",
          "Value": "Phone"
      },
      {
          "Attribute": "Source",
          "Value": "Website" 
      },
      {
          "Attribute": "mx_Secondary_Source",
          "Value": "Website - Anandlab.com" 
      },
      {
          "Attribute": "mx_City",
          "Value": "Bengaluru" 
      },
      {
          "Attribute": "mx_State",
          "Value": "Karnataka" 
      },
      {
          "Attribute": "mx_Owner_Group",
          "Value": "NADL"
      },
      {
          "Attribute": "mx_LIMS_ID",
          "Value": "2"
      },
      {
          "Attribute": "mx_Zip",
          "Value": "" 
      },
      {
          "Attribute": "Patient Stage",
          "Value": "Open" 
      },
      {
          "Attribute": "mx_Digital_Lead",
          "Value": "True" 
      },
      {
          "Attribute": "mx_Digital_Source_Name",
          "Value": "Bengaluru_SEM_Web" 
      },
      {
          "Attribute": "mx_Digital_Update_Date",
          "Value": formattedDateTime
      },
      // Optional: Map specific UTM fields to dedicated Lead Details custom fields if available
      {
        "Attribute": "mx_UTM_Source", // <--- Use your actual LeadSquared Schema Name
        "Value": capturedUtmData.utm_source
      },
      {
        "Attribute": "mx_UTM_Medium", // <--- Use your actual LeadSquared Schema Name
        "Value": capturedUtmData.utm_medium
      },
      {
        "Attribute": "mx_UTM_Campaign", // <--- Use your actual LeadSquared Schema Name
        "Value": capturedUtmData.utm_campaign
      },
      // 👇 ADDED GCLID FIELD MAPPING HERE
      {
        "Attribute": "mx_Google_Click_Id", // <--- **REPLACE with your actual LeadSquared GCLID Schema Name**
        "Value": capturedUtmData.gclid
      }
      ],
      "Activity": {
        "ActivityEvent": 207,
        "ActivityNote": `Anand at Home Lead. Campaign: ${utmNote}.${gclidNote}. Full Params: ${notesValue}`, 
        "ActivityDateTime": formattedDateTimeActivity,
        "Fields": [
           
            {
                "SchemaName": "Status",
                "Value": "Active"
            },
            {
                    "SchemaName": "mx_Custom_72",
                    "Value": "Website-Desktop"
             },
            {
                    "SchemaName": "mx_Custom_71",
                    "Value": "Landing Pages" // Added this schema and value for landing page-- updated on 14-June-2025

             }
            
        ]
    }
    }
      setLoading(true)
      data.page = 'ANAND AT HOME'
      data.page_url = window.location.href
      data.notes = notesDataString;
      axios.post("https://api-in21.leadsquared.com//v2/ProspectActivity.svc/CreateCustom", formData, {
        headers: {
          'x-LSQ-AccessKey': 'u$r8ac1be138c21c3321c9bc9c08dfae9e1',
          'x-LSQ-SecretKey': 'cc60394521a574386998a20654649546cf0dbdb3',
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        navigate("/anand-at-home-thank-you");
        setLoading(false)
        setOpen(!open)
      })
      // axios.post(API_URL.LANDING_PAGES_FORM, data).then((res) => {
      //   navigate("/anand-at-home-thank-you");
      //   setLoading(false)
      //   setOpen(!open)
      // });
      // console.log('Form submitted successfully');

  }
  
  useEffect(() => {
    document.title = "Book A Home Collection | Neuberg Anand";
    window.scroll(0, 0);
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    // gtag("config", "AW-10841898141");
    gtag('config', 'G-8VQRMYBYFG');

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = 'Discover the convenience of Lab Testing at Home with Neuberg Anand. Our hassle-free and convenient Home Collection bring the lab to you, ensuring a stress-free and comfortable experience in the familiar surroundings of your home. Prioritise your health at home with Neuberg Anand. Lab Tests Anytime, Anywhere. ';
    document.head.appendChild(metaDescription);

    const metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    metaKeywords.content = 'anand diagnostic, blood test, lab test home collection, anand lab bangalore, diagnostic centre near me open now, anand laboratory, full body test, health checkup bangalore, thyroid test price, allergy testing, cbc test price, allergy skin patch test, hcg test, immunology tests, blood sugar test, NST testing, NIPT testing, lipid profile test, diabetes tests, kidney test';
    document.head.appendChild(metaKeywords);
  }, []);

  const gtmScript1 = document.createElement('script');
  gtmScript1.async = true;
  gtmScript1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10841898141';

  const gtmScript2 = document.createElement('script');
  gtmScript2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-10841898141');
    `;

  const gtmScript3 = document.createElement('script');
  gtmScript3.innerHTML = `
      gtag('config', 'AW-10841898141/8FEGCJn-otAZEJ356LEo', {
        'phone_conversion_number': '+917823946731'
      });
    `;

  const gtmScript4 = document.createElement('script');
  gtmScript4.innerHTML = `
      gtag('config', 'AW-10841898141/GDwECMeVpv0YEJ356LEo', {
        'phone_conversion_number': '+917823946731'
      });
    `;

  const gtmScript8 = document.createElement("script");
  gtmScript8.innerHTML = `
      gtag('config', 'AW-10841898141/QgvjCPu13tMZEJ356LEo', {
        'phone_conversion_number': '+917823946731'
      });
  `;

  // Append the script tags to the head of the document
  document.head.appendChild(gtmScript1);
  document.head.appendChild(gtmScript2);
  document.head.appendChild(gtmScript3);
  document.head.appendChild(gtmScript4);
  document.head.appendChild(gtmScript8);

   useEffect(() => {
    // Facebook Pixel
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '669135594298633');
    window.fbq('track', 'PageView');

    // Google Analytics
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-8VQRMYBYFG';
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'G-8VQRMYBYFG');
    };
  }, []);
  
  return (
    <>

      <Helmet>
        {/* <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-10841898141"
        ></script> */}
              <noscript>{`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=669135594298633&ev=PageView&noscript=1" />`}</noscript>

        <script async src="https://www.googletagmanager.com/gtag/js?id=G-8VQRMYBYFG"></script>
      </Helmet>

      <div>
        <section className="abt-secton forumn-frm mt-8">
          <div className="container">
            <div className="row flex-column-reverse flex-lg-row">
              <div className="col-lg-7">
                <div className="common-heading">
                  <h2>
                    <span className="inlne">Your Health, Your Comfort </span> <br />
                    Delivered to Your Doorstep
                  </h2>
                  <img src={anandhome} alt="Anand at Home Collection Box for Lab Testing – A white box with the 'Anand' logo, designed for convenient and secure collection of samples for laboratory testing at home with contact information written on it" className="img-fluid" />
                  <br />
                  <br />
                  <div className="common-para1 drk detilos-expl text-justify indication-details p-0">
                    <p>At <b>Neuberg Anand Reference Laboratory</b> (formerly known as <b>Anand Diagnostic Laboratory / Anand Lab</b>), we believe that taking care of your health should be simple and stress-free. With our <b>Home Collection Service</b>, we bring our trusted diagnostic expertise right to your doorstep. Whether it's routine health checkups or specialized tests, you no longer need to step out—our team ensures safe, reliable, and hassle-free sample collection from the comfort of your home.</p>
                    {/* <ul>
                      <li>Sample collection done right at your doorstep</li>
                      <li>Easy/multiple booking channels- Telephone, Whatsapp, Email, Live Chat, Online Appointment Form</li>
                      <li>Home Care Kit: A complete sample collection kit, sealed for one time use only</li>
                      <li>Since 1974, Ensuring Care in Healthcare, putting customer convenience first</li>
                    </ul>
                    <br />
                    <b>With Anand@home and the Home Care Kit, we're bringing the finest healthcare experience right to your doorstep.</b> */}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-5 mb-5">
                <div className="contact-number-container-home">
                  <a href="tel:+917823946731 " className="call-icon-home shadow-lg"> <i className="fa fa-phone"></i>+91 7823946731 </a>
                </div>
                <div className="green-bg ps-rel franc-isemed animated fadeInRight">
                  <h4 className="mb-3 text-center text-white">Enquire Now</h4>
                  <form onSubmit={handleSubmit(contactUsFrom)}>
                    <div className="formdata">
                      {errors?.name ? <small className='text-danger'>{errors?.name?.message}</small> : ''}
                      <input {...register('name')} type="text" placeholder="Enter Your Name" className='form-control' disabled={verifyEnable} />
                    </div>
                    <div className="formdata">
                      {errors?.email ? <small className='text-danger'>{'Email is a invalid field'}</small> : ''}
                      <input {...register('email')} type="email" placeholder="Enter Your Email" className='form-control' disabled={verifyEnable} />
                    </div>
                    <div className="formdata">
                      {errors?.mobile ? <small className='text-danger'>{'Mobile is a invalid field'}</small> : ''}
                      <div class="form-send-otp">
                        <input {...register('mobile')} type="tel" placeholder="Enter Your Mobile Number" className='form-control'disabled={!formEnable} />
                        <button class="send-otp" id="send-otp" type="button" onClick={()=> sendOTP()} 
                          disabled={!sendOTPEnable || !formEnable}
                          >
                          Send OTP
                        </button>
                      </div>
                    </div> 

                    {verifyEnable &&
                      <div className="formdata">
                        {errors?.otp ? <small className='text-danger'>{'Verify OTP is a invalid field'}</small> : ''}
                        <div class="form-send-otp">
                          <input {...register('otp')} type="tel" placeholder="Verify OTP" className='form-control' />
                          <button class="send-otp" id="send-otp" type="button" onClick={()=>{verifyOTP()}} 
                            disabled={!formEnable}
                            >Verify OTP</button>
                        </div>
                      </div> 
                    }

                    {/* <div className="formdata">
                      {errors?.mobile ? <small className='text-danger'>{'Mobile is a invalid field'}</small> : ''}
                      <input {...register('mobile')} type="tel" placeholder="Enter Your Mobile Number" className='form-control' />
                    </div> */}
                    
                    <h6 className="text-light">
                      {/* Please enter your details and we will reach out to you as soon as we can. */}
                    </h6>
                    {/* {errors?.message ? <div><small className='text-danger'>{'Choose any one!'}</small></div> : ''} */}
                    {/* <div className="d-flex input-box">
                      <p>
                        <input type="radio" id="test1" value="Contact me on call" name="radio-group"  {...register('message')} />
                        <label for="test1">Call</label>
                      </p>
                      <p>
                        <input type="radio" id="test2" value="Contact me on Whatsapp" name="radio-group"  {...register('message')} />
                        <label for="test2">Whatsapp</label>
                      </p>
                      <p>
                        <input type="radio" id="test3" value="Contact me on Email" name="radio-group"  {...register('message')} />
                        <label for="test3">Email</label>
                      </p>
                    </div> */}
                    {/* <ReCAPTCHA
                      sitekey="6Lf_BRIqAAAAAOD6XxxBdBiNnV0EuYM0Hsg1wp_M" // Replace with your actual site key
                      onChange={handleRecaptchaChange}
                    /> */}
                    <div className="formdata">
                      {
                        Loading === true
                          ?
                          <button type="submit" disabled className="btn-primary btn-flx-full">
                            <CgSpinner className="fa-spin mr-2" />
                            Loading ...
                          </button>
                          :
                          <button type="submit" className="btn-primary btn-flx-full" disabled={formEnable}>
                            Submit
                          </button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="our-commitment-container">
            <h4 className="section-heading">Our Commitment</h4>

            <div className="insider-comm-box">
              <div className="commitment-info-container">
                <div className="commitment-info">
                  <img src={commitmentIcon2} alt="" />
                  <h4>Safety First</h4>
                  <p>Ensuring a safe and comfortable testing process.</p>
                </div>
                <div className="commitment-info">
                  <img src={commitmentIcon3} alt="" />
                  <h4>Quality Care</h4>
                  <p>
                    Our team is dedicated to providing personalized care and
                    support.
                  </p>
                </div>
                <div className="commitment-info">
                  <img src={commitmentIcon1} alt="" />
                  <h4>Quick Turnaround Time</h4>
                  <p>Get your test reports within 24 hours — download online for fast, convenient access.</p>
                </div>
              </div>
            </div>
          </div>

          <div className={`container py-5`}>
            <div className="row">
              <div className={`col-12 mb-4`} >
                <h3 className={`${GlobalStyle.purple_text} fw-bold text-center ${GlobalStyle.section_heading}`}>How It Works </h3>
              </div>

              <div className="col-md col-sm-4">
                <div className={`${GlobalStyle.how_it_work_module}`}>
                  <img src={how_work1} alt="icon" className="d-block mx-auto mb-4 img-fluid" />
                  <span>Share your details with us</span>
                </div>
              </div>
              <div className="col-md col-sm-4">
                <div className={`${GlobalStyle.how_it_work_module}`}>
                  <img src={how_work2} alt="icon" className="d-block mx-auto mb-4 img-fluid" />
                  <span>Schedule the test at your home</span>
                </div>
              </div>
              <div className="col-md col-sm-4">
                <div className={`${GlobalStyle.how_it_work_module}`}>
                  <img src={how_work4} alt="icon" className="d-block mx-auto mb-4 img-fluid" />
                  <span>Our phlebotomist would visit your home</span>
                </div>
              </div>
              <div className="col-md col-sm-4">
                <div className={`${GlobalStyle.how_it_work_module}`}>
                  <img src={how_work5} alt="icon" className="d-block mx-auto mb-4 img-fluid" />
                  <span>Get your reports online</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </>
  );
}
